module.exports = __webpack_public_path__ + "img/quest_visualization_quest_pending_11.2bde0a7b.svg";